(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px"
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-animated');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    document.querySelectorAll('.product-grid__item').forEach(item => {
      observer.observe(item);
    });

    const resultsList = document.querySelector('results-list');
    if (resultsList) {
      const mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && node.classList.contains('product-grid__item')) {
              observer.observe(node);
            } else if (node.nodeType === 1) {
              node.querySelectorAll('.product-grid__item').forEach(child => observer.observe(child));
            }
          });
        });
      });
      mutationObserver.observe(resultsList, { childList: true, subtree: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-content"] && !Shopify.designMode) return;
  try {
    
  /*
   * Cross Slide Reveal — IntersectionObserver
   * Marks the section ready on load, then triggers visible when
   * the section enters the viewport (20% threshold on desktop,
   * 10% on mobile). Theme Editor reloads are handled cleanly.
   */
  (function () {
    'use strict';

    var THRESHOLD_DESKTOP = 0.20;
    var THRESHOLD_MOBILE  = 0.10;

    function getThreshold() {
      return window.matchMedia('(min-width: 750px)').matches
        ? THRESHOLD_DESKTOP
        : THRESHOLD_MOBILE;
    }

    function initSection(section) {
      /* Skip if already set up or if running in Shopify visual preview */
      if (section.dataset.csrReady || section.dataset.shopifyVisualPreview !== undefined) return;

      /* Mark ready — hides panels offscreen via CSS */
      section.dataset.csrReady = 'true';

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.dataset.csrVisible = 'true';
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: getThreshold() }
      );

      observer.observe(section);
    }

    function initAll(root) {
      (root || document)
        .querySelectorAll('[data-testid="media-with-content"]')
        .forEach(initSection);
    }

    /* Run on page load */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    /* Re-run when Theme Editor reloads a section */
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
